<template>
  <question-template name="isRegisteredVat" :info="info" />
</template>

<script>
export default {
  name: "Vat",
  computed: {
    answer2NextPath: function () {
      const answers = this.$store.getters["questions/getAnswers"];
      if (answers.taxType === "corp") {
        return "/summaries/corp_not_register";
      }
      return "/summaries/personal_not_register";
    },
  },
  data() {
    return {
      info: {
        title: "VAT คืออะไร",
        path: "/info/vat_definition",
      },
    };
  },
};
</script>

<style scoped></style>
